import React from 'react'

// utils/formatters.js
export const formatCitiesList = cities => {
  if (!Array.isArray(cities)) return ''

  return cities
    .map(city => city.replace(/_/g, ' '))
    .map(city => city.replace(/\b\w/g, c => c.toUpperCase()))
    .join(', ')
}

export const leadProviderListColumns = (
  WhatsappButton,
  RatingComponent,
  ProviderEvaluationContent
) => [
  {
    field: 'rating',
    headerName: 'Nota atual',
    width: 100,
    editable: false,
  },
  {
    field: 'generalAverageRate',
    headerName: 'Avaliação de imobiliárias',
    width: 250,
    renderCell: params => (RatingComponent ? RatingComponent({ params }) : null),
    renderHeader: () => (
      <div
        className="MuiDataGrid-columnHeaderTitle"
        style={{ lineHeight: '1.2', whiteSpace: 'normal', textAlign: 'left' }}
      >
        Avaliação de imobiliárias
      </div>
    ),
    editable: false,
  },
  {
    field: 'agencyAverageRate', // Usually mapped to refera rate or similar in other views, but user asked for "Avaliação Refera" which is often 'score' or derived.
    // In DataTable: referaRate -> ProviderEvaluationContent
    // In DataTable: generalRate -> Avaliação de imobiliárias
    // In DataTable: agencyRate -> Minha avaliação
    // User asked for "Avaliação Refera" -> This is usually the internal score/level.
    headerName: 'Avaliação da Refera',
    width: 200,
    renderCell: params =>
      ProviderEvaluationContent ? ProviderEvaluationContent({ params }) : null,
    renderHeader: () => (
      <div
        className="MuiDataGrid-columnHeaderTitle"
        style={{ lineHeight: '1.2', whiteSpace: 'normal', textAlign: 'left' }}
      >
        Avaliação da Refera
      </div>
    ),
    editable: false,
  },
  {
    field: 'name',
    headerName: 'Nome',
    flex: 1,
    editable: false,
  },
  {
    field: 'personResponsibleName',
    headerName: 'Responsável',
    flex: 1,
    editable: false,
  },
  {
    field: 'phone',
    headerName: 'Whatsapp',
    width: 100,
    editable: false,
    renderCell: params => WhatsappButton({ phone: params.value, row: params.row }),
  },
  {
    field: 'categories',
    headerName: 'Categorias',
    flex: 1,
    editable: false,
  },
  {
    field: 'cities',
    headerName: 'Cidades de atendimento',
    flex: 1,
    editable: false,
    valueGetter: params => formatCitiesList(params.value),
  },
  {
    field: 'contactEmail',
    headerName: 'E-mail',
    flex: 1,
    editable: false,
  },
]

export const confirmationMenuTypes = ['import']
